import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';

import { Link } from 'core/routing';
import { Follow } from 'apps/content/views/follow';

import {
  AuthorSection,
  AuthorAvatar,
  FullName,
  Bio,
  ContentWrapper,
} from 'apps/story/views/authorDetails.styles';

export const AuthorDetails = observer(props => {
  const { story } = props;
  const { creatorProfile, isOwnStory } = story;
  return (
    <AuthorSection>
      <Link name='profile' params={{ profile: creatorProfile.username }}>
        <AuthorAvatar
          src={imageSrc(
            creatorProfile.avatar,
            creatorProfile.imageFallbackPath,
            mainConf.imgSizes.profile.large,
          )}
        />
      </Link>
      <ContentWrapper>
        <Link name='profile' params={{ profile: creatorProfile.username }}>
          <FullName>{creatorProfile.fullName}</FullName>
        </Link>
        <Bio>{creatorProfile.bio}</Bio>
        <Follow small content={creatorProfile.content} show={!isOwnStory} />
      </ContentWrapper>
    </AuthorSection>
  );
});

AuthorDetails.propTypes = {
  story: PropTypes.object,
};
